import { SurveysService } from "@/common/api.service";
import { FETCH_SURVEYS_DATA, FETCH_INDIVIDUAL_SURVEY_DATA, RESET_STATE } from "./actions.type";
import { SET_SURVEYS_DATA, SET_INDIVIDUAL_SURVEY_DATA,SET_SURVEY_ERROR, STATE_RESET } from "./mutations.type";


const initialState = () => {
  return {
    surveydata: [],
    individualsurveydata: [],
    surveyerror: [],
  }
};

export const state = initialState();

const actions ={

  async [FETCH_SURVEYS_DATA](context, slug) {
    return await SurveysService.get(slug).then((response) => {
      context.commit(SET_SURVEYS_DATA, response.data)
      return response
    }).catch(({ response }) =>{
      context.commit(SET_SURVEY_ERROR, response.data.errorMessage)
      return response
    })
  },

  async [FETCH_INDIVIDUAL_SURVEY_DATA](context, slug) {
    return await SurveysService.get(slug).then(({ data }) => {
      context.commit(SET_INDIVIDUAL_SURVEY_DATA, data.data)
      return data
    }).catch(({ response })=>{
      context.commit(SET_SURVEY_ERROR, response.data.errorMessage)
      return response
    })
  },


  [RESET_STATE]({ commit }) {
    commit(STATE_RESET)
  }

}

const mutations = {

  [SET_SURVEYS_DATA](state, surveydata) {
    state.surveydata = surveydata
  },
  [SET_INDIVIDUAL_SURVEY_DATA](state, individualsurveydata) {
    state.individualsurveydata = individualsurveydata
  },
  [SET_SURVEY_ERROR](state, error) {
    state.surveyerror = error
  },  
  [STATE_RESET](state) {
    Object.assign(state,initialState())
  }

}

const getters = {
  
  surveydata(state) {
    return state.surveydata;
  },
  individualsurveydata(state) {
    return state.individualsurveydata;
  },


}

export default {
    state,
    getters,
    actions,
    mutations
};